<template>
  <div class="swipeable-bottom-sheet">
    <swipeable-bottom-sheet>
      <slot name="content" />
    </swipeable-bottom-sheet>
  </div>
</template>
<style type="scss" scoped></style>
<script>
import { SwipeableBottomSheet } from "vue-swipeable-bottom-sheet";
export default {
  name: "step",
  components: { SwipeableBottomSheet },
  data() {
    return {};
  },
};
</script>
